// extracted by mini-css-extract-plugin
export var copyright = "Footer-module--copyright--v7mXx";
export var footer = "Footer-module--footer--rLNBC";
export var wrapper = "Footer-module--wrapper--RmTmE";